import { Link } from "gatsby";
import React from "react";
import { Link as LinkScroll } from "react-scroll";
import { slug } from "../../../utils/slug";

const CustomLink = ({ data, cls }) => {
  const isHomePage =
    typeof window !== "undefined" && window.location.pathname === "/";

  if (data.linkType === "url") {
    return (
      <a
        className={cls}
        href={data.url}
        aria-label={data.menutitle}
        target="_blank"
        rel="noreferrer"
      >
        {data.menutitle}
      </a>
    );
  } else if (data.linkType === "id") {
    if (isHomePage) {
      return (
        <LinkScroll
          to={data.id}
          className={`${cls} cursor-pointer`}
          smooth
          duration={200}
          offset={-120}
        >
          {data.menutitle}
        </LinkScroll>
      );
    } else {
      return (
        <Link to={`/#${data.id}`} className={cls} activeClassName="active_link">
          {data.menutitle}
        </Link>
      );
    }
  } else if (data.linkType === "upload") {
    return (
      <a className={cls} href={data.pdf.asset.url} target="_blank">
        {data.menutitle}
      </a>
    );
  } else {
    return (
      <Link
        to={slug(data.slug.current)}
        className={cls}
        activeClassName="active_link"
      >
        {data.menutitle}
      </Link>
    );
  }
};

export default CustomLink;
